import { Container } from '@chakra-ui/react';
import { GetServerSidePropsContext } from 'next';
import { getSession } from 'next-auth/react';
import { useIntl } from 'react-intl';

import { withSession } from '@/lib/session';
import { withCommonServerSideProps } from '@/lib/withCommonServerSideProps';

import EventsGrid from '@/components/News/EventsGrid';
import { PageTitle } from '@/components/PageTitle/PageTitle';
import Pagination from '@/components/Pagination';
import Seo from '@/components/Seo';

import { EventContent, StrapiDataObject, StrapiMetaObject } from '@/models/cms';
import { LocaleProps } from '@/models/props/LocalizationProps';
import { EventsService } from '@/services';

type EventsPageProps = {
    events: StrapiDataObject<EventContent>[];
    meta: StrapiMetaObject;
};

function EventsPage(props: EventsPageProps & { page: number }) {
    const { events, meta } = props;
    const intl = useIntl();

    return (
        <>
            <Seo title={intl.formatMessage({ id: 'page.events.title' })} />
            <Container maxW="container.xl" paddingY={10} my={6}>
                <PageTitle title="page.events.title" />
                <EventsGrid events={events} />
                <Pagination pageCount={meta.pagination.pageCount} page={meta.pagination.page} />
            </Container>
        </>
    );
}

export const getServerSideProps = withCommonServerSideProps(
    withSession(async (context: GetServerSidePropsContext) => {
        const session = await getSession(context);
        const { locale } = context;
        const {
            query: { page = 1 }
        } = context;

        const events = await EventsService.getEvents({
            locale: locale as LocaleProps,
            pageSize: 10,
            page: +page,
            sort: 'orderNumber',
            order: 'asc'
        });

        const { data = [], meta } = events;

        if ((!session && !events) || data.length === 0 || isNaN(+page)) {
            return {
                props: {
                    events: data,
                    meta,
                    page: +page
                }
            };
        }

        return {
            props: {
                events: data,
                meta,
                page: +page
            }
        };
    })
);

export default EventsPage;
